import BrightCove from './BrightCove.component';

export default BrightCove;